import { api } from 'data/api/api'
import { moneyObjectHeader } from 'data/api/money-object-header'

import { ClosetPromoPerfrmanceResponse } from '../types/closet-promo-performance'
import { GetClosetPromotionArgs, PromotedClosetsListResp } from '../types/closet-promotions'
import { ClosetPromotionPricingResp } from '../types/closet-promotion-pricing'
import { getClosetPromotionsArgsToParams } from '../transformers/closet-promotions'
import { PromotedClosetOrderResp } from '../types/closet-promotion-order'
import { GetVasEntryPointsArgs, GetVasEntryPointsResp } from '../types/vas-entry-points'
import { ItemPerformanceResponse } from '../types/item-performance'
import { PrepareBumpOrderResp } from '../types/bump-order'
import { BumpOptionResp, GetBumpOptionsArgs } from '../types/bump-options'
import { BumpMinimumPriceResp } from '../types/bump-minimum-price'
import { GetBumpableItemsArgs, GetBumpableItemsResp } from '../types/bumpable-items'
import { GetBumpsNewMemberItemUploadMotivationResp } from '../types/bumps-new-member-item-upload-motivation'
import { GetBumpsItemsSelectionBannerResp } from '../types/bumps-item-selection-banner'

export const getClosetPromotionPerformance = () =>
  api.get<ClosetPromoPerfrmanceResponse>('promoted_closets/performances')

export const getClosetPromotions = (args: GetClosetPromotionArgs) =>
  api.get<PromotedClosetsListResp>('/promoted_closets', {
    params: getClosetPromotionsArgsToParams(args),
    headers: moneyObjectHeader,
  })

export const getClosetPromotionPricing = () =>
  api.get<ClosetPromotionPricingResp>('/promoted_closets/pricing')

export const prepareClosetPromotionOrder = () =>
  api.post<PromotedClosetOrderResp>('/promoted_closets/orders/prepare', undefined, {
    headers: moneyObjectHeader,
  })

export const getVasEntryPoints = ({ bannerNames }: GetVasEntryPointsArgs) =>
  api.get<GetVasEntryPointsResp>('/vas_entry_points', {
    params: { names: bannerNames },
  })

export const getItemPerformance = (itemId: number) =>
  api.get<ItemPerformanceResponse>(`items/${itemId}/performance`)

export const prepareBumpOrder = (
  itemIds: Array<number>,
  effectiveDays: number,
  international?: boolean,
) =>
  api.post<PrepareBumpOrderResp>(
    '/push_ups/orders',
    {
      item_ids: itemIds,
      effective_days: effectiveDays,
      international,
    },
    { headers: moneyObjectHeader },
  )

export const getBumpOptions = ({ itemIds }: GetBumpOptionsArgs) =>
  api.get<BumpOptionResp>('/push_ups/options', {
    params: { item_ids: itemIds },
    headers: moneyObjectHeader,
  })

export const getBumpMinimumPrice = () =>
  api.get<BumpMinimumPriceResp>('/push_ups/minimum_price', {
    headers: moneyObjectHeader,
  })

export const getBumpableItems = ({ currentPage, perPage }: GetBumpableItemsArgs) =>
  api.get<GetBumpableItemsResp>('/bumps/bumpable_items', {
    params: { per_page: perPage, page: currentPage },
  })

export const getBumpsNewMemberItemUploadMotivation = () =>
  api.get<GetBumpsNewMemberItemUploadMotivationResp>('/bumps/new_member_item_upload_motivation')

export const getBumpsItemsSelectionBanner = () =>
  api.get<GetBumpsItemsSelectionBannerResp>('/bumps/items_selection_banner')
